import { Order } from "@/api/index";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import dayjs from "dayjs";
import { OrderModal } from "./order-modal";

type OrderListProps = {
  orders: Order[];
};

const SpOrderList: React.FC<OrderListProps> = ({ orders }) => {
  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState<Order | null>(null);

  const handleOpen = (order: Order) => {
    setOrder(order);
    setOpen(true);
  };
  return (
    <div className="w-full">
      {orders.map((order, index) => (
        <div
          key={index}
          className={`bg-white border-b border-gray-300 p-6 ${index === 0 ? "border-t" : ""}`}
        >
          <div className="flex mb-2">
            <div className="text-sm font-medium mr-2">
              {dayjs(order.orderDate).format("YYYY年MM月DD日")}
            </div>
            <div className="text-sm font-medium">{order.statusI18n}</div>
          </div>
          <div className="mb-2 text-sm font-medium">
            ご注文番号：{order.orderNumber}
          </div>
          <div className="flex justify-between items-center">
            <div className="text-2xl">
              ¥ {order.totalPrice?.toLocaleString()}
            </div>
            <Button
              variant="outline"
              size="sm"
              className="border border-black rounded-none px-8 py-2.5 text-sm font-normal hover:bg-transparent"
              onClick={() => handleOpen(order)}
            >
              購入アイテムの表示
            </Button>
          </div>
        </div>
      ))}

      {order && <OrderModal open={open} order={order} setOpen={setOpen} />}
    </div>
  );
};

const OrderList: React.FC<OrderListProps> = ({ orders }) => {
  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState<Order | null>(null);

  const handleOpen = (order: Order) => {
    setOrder(order);
    setOpen(true);
  };

  return (
    <div className="w-full flex justify-center px-4">
      <div className="w-full max-w-[1200px]">
        <div className="bg-white hidden md:block">
          {orders.map((order, index) => (
            <div
              key={index}
              className={`flex items-center border-b border-gray-300 ${
                index === 0 ? "border-t" : ""
              }`}
            >
              <div className="py-6 pl-8 w-48 text-base font-medium">
                {dayjs(order.orderDate).format("YYYY年MM月DD日")}
              </div>
              <div className="py-6 w-28 text-base font-medium">
                {order.statusI18n}
              </div>
              <div className="py-6 w-96 text-base font-medium">
                ご注文番号：{order.orderNumber}
              </div>
              <div className="flex items-center gap-10 ml-auto pr-8">
                <div className="text-right text-lg font-medium whitespace-nowrap">
                  ¥ {order.totalPrice?.toLocaleString()}
                </div>
                <div className="text-right">
                  <Button
                    variant="outline"
                    size="sm"
                    className="border border-black rounded-none px-8 py-2.5 text-sm font-normal hover:bg-transparent"
                    onClick={() => handleOpen(order)}
                  >
                    購入アイテムの表示
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {order && <OrderModal open={open} order={order} setOpen={setOpen} />}
      </div>
    </div>
  );
};

export { OrderList, SpOrderList };
